import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=fa64aef8&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=fa64aef8&prod&lang=postcss&scoped=true"
import style1 from "./SignUp.vue?vue&type=style&index=1&id=fa64aef8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa64aef8",
  null
  
)

export default component.exports